import { GlobalCart } from '../../interface/order-placement.interface';

interface GlobalCartState {
  entries: GlobalCart['entries'];
  selectedEntries?: string[];
  totalCartCount?: number;
  appliedVouchers?: GlobalCart['appliedVouchers'];
  branch?: GlobalCart['branch'];
  stampDutyFee?: GlobalCart['stampDutyFee'];
  subTotal?: GlobalCart['subTotal'];
  totalDiscounts?: GlobalCart['totalDiscounts'];
  strikeThroughPrice?: GlobalCart['strikeThroughPrice'];
  cartCode?: string;
  isGlobalCartPending?: boolean;
}

enum GlobalCartActionKind {
  HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__',
  RESET_GLOBAL_CART_STATE = 'RESET_GLOBAL_CART_STATE',
  SET_GLOBAL_CART_ALL_STATE = 'SET_GLOBAL_CART_ALL_STATE',
  SET_GLOBAL_CART_ALL_ENTRIES = 'SET_GLOBAL_CART_ALL_ENTRIES',
  SET_GLOBAL_CART_ENTRIES = 'SET_GLOBAL_CART_ENTRIES',
  SET_GLOBAL_CART_BRANCH = 'SET_GLOBAL_CART_BRANCH',
  SET_GLOBAL_CART_TOTAL_COUNT = 'SET_GLOBAL_CART_TOTAL_COUNT',
  SET_GLOBAL_CART_SELECTED_ENTRIES = 'SET_GLOBAL_CART_SELECTED_ENTRIES',
  SELECT_GLOBAL_CART_ENTRY = 'SELECT_GLOBAL_CART_ENTRY',
  SET_GLOBAL_CART_CODE = 'SET_GLOBAL_CART_CODE',
  SET_GLOBAL_CART_IS_GLOBAL_CART_PENDING = 'SET_GLOBAL_CART_IS_GLOBAL_CART_PENDING',
}

interface GlobalCartAction {
  type: GlobalCartActionKind;
  payload?: any;

  entries?: GlobalCart['entries'];
  selectedEntries?: string[];
  uuid?: string;

  totalCartCount?: number;
  appliedVouchers?: GlobalCart['appliedVouchers'];
  branch?: GlobalCart['branch'];
  stampDutyFee?: GlobalCart['stampDutyFee'];
  totalPrice?: GlobalCart['totalPrice'];
  subTotal?: GlobalCart['subTotal'];
  totalDiscounts?: GlobalCart['totalDiscounts'];
  strikeThroughPrice?: GlobalCart['strikeThroughPrice'];
  cartCode?: string;

  isGlobalCartPending?: GlobalCartState['isGlobalCartPending'];
}

export { type GlobalCartState, GlobalCartActionKind, type GlobalCartAction };
